module.exports = __webpack_public_path__ + "static/media/bcci_logo.88442be8.png";